/**
 * author: Alex Lai
 * Support Website: https://laialex.com
 * Email: alex@laialex.com
 * Create Time: 2023/11/9
 */

import React,{Component} from "react";
import * as UI from "antd";
import { PageHeader } from '@ant-design/pro-layout';
import apis from "../../../../utils/apis";
import {BellOutlined} from "@ant-design/icons";



const {TextArea} = UI.Input
const {Option} = UI.Select

export default class Registry extends Component{
    constructor() {
        super();
        this.state = {
            tableData: [],
            paging: {total: 0,pageNumber: 1, pageSize: 20},
            tableLoad: false,
            searchKey: {},
            editShow: false,
            editCurr: {},
            submitting: false,
            executeGroup: []
        }
    }
    componentDidMount() {
        this.executeGroupSync()
        this.tableDataSync(1)
    }

    /**
     * 加载执行分组
     */
    executeGroupSync () {
        var param = {}
        param.pageNumber = 1
        param.pageSize = 2000
        var that = this
        apis.schedulerGroups(param).then(res => {
            that.setState({
                executeGroup: res.data.data.data
            })
        })
    }

    /**
     * 发起搜索
     * @param params
     * @constructor
     */
    makeSearch=(params)=>{
        this.setState({
            searchKey: params
        })
        var that = this
        setTimeout(function () {
            that.tableDataSync()
        },200)
    }
    /**
     * 签名列表
     * @param pageNumber
     Object.assign(para, that.state.keywords)
     * @param pageSize
     * @constructor
     */
    tableDataSync=(pageNumber=1)=>{
        let that = this;
        let para = {};
        para.pageNumber = pageNumber;
        para.pageSize = 20;
        that.setState({
            tableLoad: true
        })
        Object.assign(para,that.state.searchKey)
        apis.schedulerRegistryList(para).then(function (resp) {
            that.setState({
                tableLoad: false
            })
            var curr = {
                total: resp.data.data.total,
                pageNumber: pageNumber
            }
            that.setState({
                tableData: resp.data.data.data,
                paging: curr
            })
        })
    }



    render() {
        var that = this

        const  columns = [
            {
                title: "ID",
                dataIndex: "id"
            },
            {
                title: "执行器名称",
                key: "id",
                render: function (value, row, index) {
                    return (
                        <div style={{fontSize:"22px",color:"darkcyan"}}>{row.name}</div>
                    )
                }
            },
            {
                title: "绑定分组",
                key: "id",
                render: function (value, row, index) {
                    return (
                        <div>{row.group.app_name}</div>
                    )
                }
            },
            {
                title: "执行地址",
                key: "id",
                render: function (value, row, index) {
                    return (
                        <UI.Button shape={"round"} type={"dashed"}>{row.value}</UI.Button>
                    )
                }
            },
            {
                title: "可用",
                key: "id",
                render: function (value, row, index) {
                    return (
                        <UI.Button shape={"round"} type={"circle"}>{row.state ?　'是' : '否'}</UI.Button>
                    )
                }
            },
            {
                title: "管理",
                key: "id",
                fixed: "right",
                render: function (value, row, index) {
                    return (
                        <span>
                             <UI.Button onClick={()=>{
                                 var data = JSON.parse(JSON.stringify(row))
                                 data.group = data.group.id
                                 that.setState({
                                     editCurr: data,
                                     editShow: true
                                 })
                             }} type={"link"}>编辑</UI.Button>
                        </span>
                    )
                }
            }
        ]

        return (
            <div>
                <PageHeader title="执行客户端管理" subTitle="手机挂载执行器到分发中心" extra={[
                    <UI.Button  key="1" type="primary" shape="round" onClick={()=>{
                        that.setState({
                            editCurr: {},
                            editShow: true,
                            submitting: false
                        })
                    }}>注册客户端</UI.Button>
                ]}/>
                <div style={{color:"darkcyan", fontSize:"10px",marginBottom:"16px"}}><BellOutlined /> 免费用户可注册两个执行终端，每天总运行CU为500</div>
                <UI.Card>
                    <div style={{marginTop:'22px'}}>
                        <UI.Form onFinish={that.MakeSearch} layout={"inline"}>
                            <UI.Form.Item label={"执行客户端名称"} name={"name__contains"}>
                                <UI.Input placeholder={"执行客户端名称"}/>
                            </UI.Form.Item>
                            <UI.Form.Item>
                                <UI.Button type={"primary"} htmlType={"submit"}>快递搜索</UI.Button>
                            </UI.Form.Item>
                        </UI.Form>
                    </div>
                </UI.Card>

                <div style={{marginTop:'22px'}}>
                    <UI.Table
                        rowKey="id"
                        dataSource={this.state.tableData}
                        columns={columns}
                        loading={this.state.tableLoad}
                        pagination={{total:this.state.paging.total,defaultPageSize:20,defaultCurrent:this.state.paging.pageNumber,onChange:this.tableDataSync}}/>
                </div>

                <UI.Modal visible={that.state.editShow} title={'定时任务执行客户端名称'} onCancel={()=>{
                    that.setState({
                        editCurr: {},
                        editShow: false,
                        submitting: false
                    })
                }} footer={null} destroyOnClose>
                    <UI.Form onFinish={(params => {
                        that.setState({
                            submitting: true
                        })
                        if (that.state.editCurr.id) {
                            params.id = that.state.editCurr.id
                        }
                        apis.schedulerExecuteRegistry(params).then(resp => {
                            that.setState({
                                submitting: false
                            })
                            if (resp.data.code === 200 && resp.data.data.code === 200) {
                                UI.message.success("提交信息成功")
                                that.tableDataSync(that.state.editCurr.id ? that.state.paging.pageNumber : 1)
                                that.setState({
                                    submitting: false,
                                    editShow: false,
                                    editCurr: {}
                                })
                            } else {
                                UI.message.error(resp.data.data.msg ? resp.data.data.msg : resp.data.msg)
                            }
                        })
                    })} labelCol={{span:24}} labelAlign={"left"} initialValues={that.state.editCurr}>
                        <UI.Form.Item label={"执行客户端名称"} name={"name"} rules={[{required:true,message:'执行客户端名称'}]}>
                            <UI.Input placeholder={"执行客户端名称"} disabled={that.state.editCurr.id}/>
                        </UI.Form.Item>
                        <UI.Form.Item label={"执行组"} name={"group"} rules={[{required:true,message:'执行组'}]}>
                            <UI.Select placeholder={"先选择你要配置的执行组"}  style={{width:"100%"}}>
                                {that.state.executeGroup.map(item => {
                                    return (
                                        <Option value={item.id} key={item.id}>{item.app_name}</Option>
                                    )
                                })}
                            </UI.Select>
                        </UI.Form.Item>
                        <UI.Form.Item label={"执行客户端名称"} name={"state"} rules={[{required:true,message:'执行客户端名称'}]}>
                            <UI.Radio.Group>
                                <UI.Radio value={true}>可用</UI.Radio>
                                <UI.Radio value={false}>禁用</UI.Radio>
                            </UI.Radio.Group>
                        </UI.Form.Item>
                        <UI.Form.Item label={"执行器"} name={"value"} help="地址样式:http://ip:8999" rules={[{required:true,message:'执行器'}]}>
                            <UI.Input placeholder={"执行器"}/>
                        </UI.Form.Item>
                        <UI.Form.Item>
                            <UI.Button htmlType={"submit"} loading={that.state.submitting} type={"primary"} block>提交工作流节点信息</UI.Button>
                        </UI.Form.Item>
                    </UI.Form>
                </UI.Modal>
            </div>
        )
    }
}